var $ = require('jquery');

$(function () {
    if ($('[data-is-report-page]').length) {
        $('[data-report-url]').click(function (e) {
            var $this,
                loader,
                output;

            $this = $(this);

            loader = $this.closest('form').find('.loading-overlay');

            output = $('[data-output]');

            if (!loader.hasClass('hidden'))
                return;

            loader.removeClass('hidden');

            var reportUrl = $this.attr('data-report-url');

            $.ajax(
                {
                    url: reportUrl,
                    type: "POST",
                    success: function (data) {
                        if (!data) {
                            output.innerHTML = 'Data unknown';
                            return;
                        }

                        if (!!data.Data && !!data.Data.length) {
                            var filename = $this.attr('data-report-name');

                            //https://stackoverflow.com/a/44869314/2597149
                            if (navigator.msSaveBlob) { // IE 10+ 
                                navigator.msSaveBlob(new Blob([data.Data], { type: 'text/csv;charset=utf-8;' }), filename);
                            } else {
                                var encodedUri = encodeURI('data:text/csv;charset=utf-8,' + data.Data);
                                var link = document.createElement("a");
                                link.setAttribute("href", encodedUri);
                                link.setAttribute("download", filename);
                                document.body.appendChild(link); // Required for FF

                                link.click();
                            }
                        }

                        if (data.Message && $('input[name="verbose"]:checked').length) {
                            output.html(data.Message);
                        } else if (data.Success) {
                            output.html('Task complete');
                        } else {
                            output.html('Task complete with errors. Please see the logs.');
                        }
                    },
                    error: function (data) {
                        output.html('An error has occurred.');
                    },
                    complete: function (e) {
                        loader.addClass('hidden');
                    }
                });
        });
    }
});